import { combineReducers } from "redux";
import listaPedidosFracionados from "./slices/listaPedidosFracionados.slice";

const reducer = combineReducers({
  listaPedidosFracionados,
});

export default reducer;
